import { useSuspenseQuery } from '@tanstack/react-query';
import { mantangApi as api } from '@/shared/api';
import { favoritesKeys } from '../api/favorites.keys';

const useFavoriteStations = () => {
	const { data, ...rest } = useSuspenseQuery({
		queryKey: favoritesKeys.all,
		queryFn: api.getFavoriteStationsWithDetails,
		staleTime: Infinity,
	});

	return { data: data.data || [], ...rest };
};

export default useFavoriteStations;
